<div class="input-group">

    <input id="date" name="date" class="form-control bg-white" type="text" ngbDatepicker #d="ngbDatepicker"
        [minDate]="minDate" [startDate]="toNgbDate(today)" [value]="formattedDate" [navigation]="navigation"
        (click)="d.toggle()" (dateSelect)="onDateFromSelect($event)" readonly [markDisabled]="isDateDisabled" />
    <!-- value="September 1, 2021"   -->
</div>